module.exports = __webpack_public_path__ + "img/logo-cdti.70c75a49.png";